import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import  { ReactComponent as ClaroLogo } from  '~/Assets/Images/Claro-logo.svg'
import  { ReactComponent as LeftArrow } from  '~/Assets/Images/seta-esquerda.svg'

import { ReactComponent as SmileFaceSVG } from '~/Assets/Images/rosto-sorrindo.svg';
import { ReactComponent as AddSVG }  from  '~/Assets/Images/mais.svg'
import { ReactComponent as Dots }  from  '~/Assets/Images/pontos.svg'

import {
  CardContainer,
   RCSPreview,
} from './styles';
import RCSCard
  from "~/Pages/Campanhas/pages/Crud/Form/Components/PreviewCriativo/pages/RCSClaroPreview/components/RCSCard";

const RCSClaroPreview = ({data}) => {
  if(!data) return null;
  const {  content, creativeDefinition : { schema: {cards, ...rest} }}= data
  const [cardsData, setCardsData] = useState({ ...cards });

  const {textCampaign, textDuploOptin, thumbnail, imageCampaign, textInfo1, textInfo2, textInfo3, imageInfo1, imageInfo2, imageInfo3, mediaType} = content;

  useEffect(() => {
    if (!cards) {
      const defaultMediaType = rest[mediaType] || rest[Object.keys(rest)[0]];
      setCardsData(defaultMediaType.cards);
    }
  }, [mediaType]);

  const [state, setState] = useState('');
  const [chatMap, setChatMap] = useState({});
  const playerRef = [];

  useEffect(() => {
    handleStateChange(state);
  }, [state]);

  const handleStateChange = (state) => {
    switch (state) {
      case 'end':
        setChatMap({});
        if (playerRef) {
          playerRef.forEach((ref) => ref.current.showPreview());
        }
        break;
      default:
        setChatMap({...chatMap, [state]: true});
        break;
    }
  }

  return (
    <RCSPreview>
      <div className='rcs-header'>
        <div>
        <LeftArrow />
        {'Claro Brasil'}
        </div>
        <Dots />
      </div>
      <div className='rcs-content'>
        {
          cardsData.card1 &&
          <>
            <RCSMessage message={textCampaign} startIcon={<ClaroLogo />} />
            <CardContainer>
            <div className='card-container'>
            <RCSCard playerRef={playerRef} card={cardsData.card1.config.textCampaign} message={textCampaign} thumbnail={thumbnail} mainContent={imageCampaign}>
              <StateChange chatMap={chatMap} setState={setState}  options={[{state: 'card4', label: 'Contratar'}]} />
            </RCSCard>
            </div>
          </CardContainer>
          </>
        }
        {
          cardsData.card2 &&
          <>
            <RCSMessage message={textInfo1} startIcon={<ClaroLogo />} />
          <CardContainer>
            <div className='card-container'>
              <RCSCard playerRef={playerRef} card={cardsData.card2.config.textInfo1} message={textInfo1} thumbnail={thumbnail} mainContent={imageInfo1}>
                <StateChange chatMap={chatMap} setState={setState}  options={[{state: 'card4', label: 'Contratar'}]} />
              </RCSCard>
              <RCSCard playerRef={playerRef} card={cardsData.card2.config.textInfo2} message={textInfo2} mainContent={imageInfo2}>
              </RCSCard>
              <RCSCard playerRef={playerRef} card={cardsData.card2.config.textInfo3} message={textInfo3} mainContent={imageInfo3}>
              </RCSCard>
            </div>
          </CardContainer>
          </>

        }
        <StateChange chatMap={chatMap} setState={setState} options={[{state: 'card3', label: 'Mais Informações'}, {state: 'end', label: 'Não, obrigado'}]} disabled={chatMap[ 'card4']} />
        {
          chatMap['card3'] &&
          (
            <>
              <RCSMessage message={`${cardsData.card3.config.textDuploOptin.valuePrefix} ${textDuploOptin} ${cardsData.card3.config.textDuploOptin.valueSuffix}`} startIcon={<ClaroLogo />} />
              <StateChange chatMap={chatMap} setState={setState} options={[{state: 'card4', label: 'Contratar'}, {state: 'end', label: 'Não, obrigado'}]} disabled={chatMap[ 'card4']} />
            </>
          )
        }
        {
          chatMap['card4'] &&
          (
            <>
              <RCSMessage message={cardsData.card4.config.successInfo} startIcon={<ClaroLogo />} />
              <StateChange chatMap={chatMap} setState={setState} options={[ {state: 'end', label: 'Reiniciar preview'}]}  />
            </>
          )
        }
      </div>
      <div className='rcs-footer'>
        <input placeholder='Digite sua mensagem...' />
        <div className='button-container'>
          <AddSVG />
          <SmileFaceSVG   />
        </div>
      </div>
    </RCSPreview>
  )
};

RCSClaroPreview.propTypes = {
};

const StateChange = ({setState, options, chatMap, disabled}) => {
  const isDisabled = disabled || options.find((option) => chatMap[option.state]);
  return (
    <div className='state-change'>
      {options.map((option, index) => (
        <button key={index} disabled={isDisabled} className={chatMap[option.state] && 'selected' } onClick={() => setState(option.state)}>{option.label}</button>
      ))}
    </div>
  )
}

const RCSMessage = ({message, startIcon, endIcon}) => (
  <div className={`rcs-message ${startIcon ? 'startIcon' : ''} ${endIcon ? 'endIcon' : ''}`}>
      {startIcon && startIcon}
    <div className="rcs-message-text">
      {message}
    </div>
    {endIcon && endIcon}
  </div>
)


// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators(
  {},
  dispatch,
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RCSClaroPreview);
